export const RAM_CONSTANTS = {
  heading: "RAM/CPU",
  options: [
    {
      title: "Reserved cloudlets",
      desc: [
        "These cloudlets are reserved in advance (using the topology wizard). You always pay for the configured reserved cloudlets, even if you use fewer resources.",
        "The discount level is the total sum of all Reserved Cloudlets per environment.",
      ],
      data: [
        {
          cloudlet: "1-63",
          pricing: {
            hourly: "$0.0023",
            discount: "25%",
          },
        },
        {
          cloudlet: "64-127",
          pricing: {
            hourly: "$0.0020",
            discount: "35%",
          },
        },
        {
          cloudlet: "128-255",
          pricing: {
            hourly: "$0.0017",
            discount: "45%",
          },
        },
        {
          cloudlet: "256-∞",
          pricing: {
            hourly: "$0.0015",
            discount: "50%",
          },
        },
      ],
    },
    {
      title: "Dynamic cloudlets",
      desc: [
        "Instant dynamic scaling resources for your application. You only pay for Dynamic Cloudlets in use. Use the Scaling Limit in the topology wizard to set the maximum allowed per server.",
        "The discount level is the total sum of all Dynamic Cloudlets in use per environment.",
      ],
      data: [
        {
          cloudlet: "1-63",
          pricing: {
            hourly: "$0.0030",
            discount: "0%",
          },
        },
        {
          cloudlet: "64-127",
          pricing: {
            hourly: "$0.0026",
            discount: "12%",
          },
        },
        {
          cloudlet: "128-255",
          pricing: {
            hourly: "$0.0024",
            discount: "20%",
          },
        },
        {
          cloudlet: "256-∞",
          pricing: {
            hourly: "$0.0021",
            discount: "30%",
          },
        },
      ],
    },
  ],
  footer: { btnText: "Ready To Try?" },
};

export const DISK_SPACE_CONSTANTS = {
  heading: "Disk Space",
  desc: "Disk space is charged hourly per GB of disk space used in your environment.",
  data: [
    {
      range: "First 10GB",
      pricing: {
        perGBHour: "FREE",
        perGBMonth: "FREE",
      },
    },
    {
      range: "10GB - ∞",
      pricing: {
        perGBHour: "$0.00007",
        perGBMonth: "$0.050400",
      },
    },
  ],
  footer: {
    btnText: "Ready To Try?",
  },
};

export const TRAFFIC_CONSTANTS = {
  heading: "Traffic",
  desc: "Traffic usage is charged hourly. The discount level is based on the amount of external traffic used per environment in the previous month. Internal traffic is absolutely free!",
  data: [
    {
      range: "1GB - 4999GB",
      discount: "FREE",
      pricePerGB: "$0.00",
    },
    {
      range: "5000GB - ∞",
      discount: "NA",
      pricePerGB: "$0.03",
    },
  ],
  footer: {
    btnText: "Subscribe ",
  },
};

export const SSL_CONSTANTS = {
  heading: "OneMind's SSL",
  data: {
    title: "OneMind's SSL",
    desc: "This is an external IP address which is directly accessible from outside of the cluster. The charge is taken hourly.",
    data: [
      {
        name: "OneMind SSL",
        pricePerHour: "FREE",
        pricePerMonth: "FREE",
      },
    ],
  },
};

export const EXTERNAL_IP_CONSTANTS = {
  heading: "External IP",
  desc: "This is a protocol which establishes a secure connection between your client and your  environment. The charge is taken hourly.",
  data: [
    {
      name: "Public IPv4",
      count: "1 - ∞",
      pricePerHour: "$0.0050",
      pricePerMonth: "$3.60",
    },
    {
      name: "Public IPv6",
      count: "1 - ∞",
      pricePerHour: "FREE",
      pricePerMonth: "FREE",
    },
  ],
  footer: {
    btnText: "Provision IP Now ",
  },
};
